import React, { useState } from "react";
import { Logo } from "../logo/Logo";
import { Link } from "react-router-dom";
import { DAUCHI_EMAIL, DAUCHI_SUPPORT_EMAIL } from "../../constants/Common";

export const DesktopFooter = ({
  treatments,
  resources,
  aboutUs,
  icons,
  partners,
}) => {
  const [seeAll, setSeeAll] = useState(false);
  const [email, setEmail] = useState("");

  const updatedTreatments = seeAll ? treatments : treatments.slice(0, 5);

  const handleSubscribe = () => {};

  return (
    <div
      id="footer-container"
      className="bg-darkPrimary flex w-full font-subHeadline"
    >
      <div
        id="footer-internal-container"
        className="my-10 mx-10 items-center w-full flex flex-col justify-between"
      >
        <div className="flex w-full md:mb-12 lg:mb-28">
          <div className="flex flex-[0.8] flex-col justify-between">
            <div id="logo-section" className="flex flex-col text-start">
              <Logo />
            </div>
            <div id="contact-section" className="text-start">
              <div className="text-secondary font-bold md:text-[25px] lg:text-[30px] 2xl:text-[35px]">
                Say Hello
              </div>
              <a
                href={`mailto:${DAUCHI_EMAIL}`}
                className="text-secondary underline  md:text-[12px] lg:text-[16px] 2xl:text-[20px]"
              >
                {DAUCHI_EMAIL}
              </a>
              <div className="text-white md:text-[12px] lg:text-[16px] 2xl:text-[20px] mt-2">
                Non-medical customer service:
              </div>
              <a
                href={`mailto:${DAUCHI_SUPPORT_EMAIL}`}
                className="text-secondary underline md:text-[12px] lg:text-[16px] 2xl:text-[20px] mb-2"
              >
                {DAUCHI_SUPPORT_EMAIL}
              </a>
              <div className="text-white md:text-[12px] lg:text-[16px] 2xl:text-[20px]">
                9:30a - 6:30p EST M-F
              </div>
              <div className="text-white md:text-[12px] lg:text-[16px] 2xl:text-[20px]">
                Phone Number: (424) 372-7851
              </div>
              <div className="text-white md:text-[12px] lg:text-[16px] 2xl:text-[20px]">
                Address: 7216 Varna Ave
              </div>
              <div className="text-white md:text-[12px] lg:text-[16px] 2xl:text-[20px]">
                North Hollywood, CA 91605
              </div>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-16 text-left ml-16">
            <div id="treatments-section" className="mb-0">
              <h1 className="text-secondary md:text-[13px] lg:text-[16px] 2xl:text-[18px]">
                Treatments
              </h1>
              <Navlinks navList={updatedTreatments} useLink={true} />
              {!seeAll && (
                <p
                  className="text-white mt-1 md:text-[14px] lg:text-[16px] 2xl:text-[20px]"
                  onClick={() => {
                    setSeeAll(true);
                  }}
                >
                  See All
                </p>
              )}
            </div>
            <div id="about-us-section" className="flex flex-col">
              <h1 className="text-secondary md:text-[13px] lg:text-[16px] 2xl:text-[18px]">
                About Us
              </h1>
              <Navlinks navList={aboutUs} useLink={true} />
              <a href={`mailto:${DAUCHI_SUPPORT_EMAIL}`}>
                <p className="text-white md:text-[14px] lg:text-[16px] 2xl:text-[20px] mt-1">
                  Email us
                </p>
              </a>
            </div>
            <div id="resources-section" className="flex flex-col text-white">
              <h1 className="text-secondary md:text-[13px] lg:text-[16px] 2xl:text-[18px]">
                Resources
              </h1>
              <Navlinks navList={resources} useLink={true} />
            </div>
            {partners.map((partner, index) => (
              <div key={index} className="flex-1 flex flex-col">
                <p className="text-secondary md:text-[13px] lg:text-[16px] 2xl:text-[18px]">
                  {partner.title}
                </p>
                {partner.details.map((detail, index) => (
                  <p
                    key={index}
                    className="text-white md:text-[14px] lg:text-[16px] 2xl:text-[20px] mt-1"
                  >
                    {detail}
                  </p>
                ))}
                <a
                  href={`mailto:${partner.email}`}
                  className="text-secondary underline  md:text-[12px] lg:text-[16px] 2xl:text-[20px]"
                >
                  {partner.email}
                </a>
              </div>
            ))}
            <div
              id="signup-section"
              className="flex flex-col flex-1 text-white text-md justify-end mb-4"
            >
              <h1 className="text-secondary md:text-[16px] lg:text-[20px] 2xl:text-[24px]">
                Sign Up for Updates
              </h1>
              <p className=" md:text-[12px] lg:text-[16px] 2xl:text-[20px] mb-4 max-w-[17rem]">
                Enter your email to receive updates from Dauchi
              </p>
              <div className="flex flex-col items-start justify-start">
                <input
                  type="email"
                  placeholder="Your Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="text-black w-full max-w-[17rem] md:h-[1.5rem] lg:h-[2.19rem] p-3 md:text-[10px] lg:text-[12px] 2xl:text-[16px]"
                />
                <button
                  className="mt-2 w-full max-w-[10.75rem] text-darkPrimary bg-secondary h-full md:text-[10px] lg:text-[14px] xl:text-[16px] 2xl:text-[20px]"
                  onClick={handleSubscribe}
                >
                  Subscribe!
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full border-t-2 border-secondary pt-10">
          <div id="social-media-handles" className="flex w-[50%]">
            {icons.map((icon, index) => {
              return (
                <div
                  key={index}
                  className="flex md:h-[2rem] md:w-[2rem] lg:h-[2.5rem] lg:w-[2.5rem] 2xl:h-[2.9rem] 2xl:w-[2.9rem] bg-secondary rounded-full lg:p-2 mr-6 items-center justify-center"
                >
                  <div className="text-darkPrimary md:text-[1.25rem] lg:text-[1.75rem] 2xl:text-[2rem]">
                    {icon.icon}
                  </div>
                </div>
              );
            })}
          </div>
          <a href="https://www.legitscript.com/websites/?checker_keywords=dauchi.com" target="_blank" title="Verify LegitScript Approval for www.dauchi.com">
            <img src="https://static.legitscript.com/seals/33241414.png" alt="Verify Approval for www.dauchi.com" width="73" height="79" />
          </a>
          <div className="text-secondary font-bodyCopy w-[50%] leading-none mt-4 text-end md:text-[12px] lg:text-[16px] 2xl:text-[20px]">
            ©2025 Dauchi. All Rights Reserved
          </div>
        </div>
      </div>
    </div>
  );
};

export const Navlinks = ({ navList, useLink = false }) => {
  return (
    <div>
      {navList.map((item, index) => {
        return (
          <div>
            {useLink ? (
              <Link key={index} to={item.href}>
                <p className="text-white mt-1 md:text-[14px] lg:text-[16px] 2xl:text-[20px]">
                  {item.name}
                </p>
              </Link>
            ) : (
              <div key={index}>
                <p className="text-white  md:text-[14px] lg:text-[16px] 2xl:text-[20px] mt-1">
                  {item.name}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
